<template>
    <div class="events container-screen">
        <LoadingScreen v-if="loadingPage" />
        <template v-else>
            <div class="events__body">
                <TitleCommon :value="`${getTranslatedText(dataSourceGames.title)} ${dataSourceGames.isPariMutuelLotto ? '' : gameNumber}`" />
                <SelectFilter :isHiddenSelect="dataSourceGames.isPariMutuelLotto" :dataOption="dataSource" :jackpot="dataSourceGames.jackpot" nameFunction="on-filter-events" />
                <div class="events__content">
                    <div class="events__list">
                        <div class="events__item" :class="{ active: eventSelect.includes(v.event_id) }" v-for="(v, i) in dataSourceFilter" :key="i" @click="onSelectEvent(v.event_id, v)">
                            <span class="events__item-title" v-if="!dataSourceGames.isPariMutuelLotto">{{ v.event_name }}</span>
                            <span class="events__item-date">{{ renderDate(v.draw_date) }}</span>
                        </div>
                    </div>
                    <div class="events_box-button">
                        <ButtonCommon v-if="!isHiddenButtonBack" type="active" :isNoHover="true" value="back" :isLoading="isLoadingButton" nameFunction="screen-game-on-handle-steps" :paramFunction="{ step: 1 }" />
                        <ButtonCommon type="error" :isNoHover="true" value="continue" :isLoading="isLoadingButton" nameFunction="on-events-continue" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { formatDate, isArrayEmpty, isSameDay, convertDate, isObjEmpty } from '@/utils/utils'

import GamesService from '@/services/games.service'
import pathAssetsMixins from '@/mixins/pathAssets/path-assets-mixins'
import languageMixins from '@/mixins/language/language-mixins'
import customDrawNamesMixin from '@/mixins/customDrawNames/custom-draw-names-mixin'
import EventBus from '@/utils/EventBus'
import ButtonCommon from '@/components/common/button/index.vue'
import LoadingScreen from '@/components/common/loading/index.vue'
import TitleCommon from '@/components/common/title/index.vue'
import SelectFilter from '@/components/games/events/select/index.vue'

export default {
    mixins: [pathAssetsMixins, languageMixins, customDrawNamesMixin],
    components: { ButtonCommon, SelectFilter, LoadingScreen, TitleCommon },
    props: {
        propsDataGames: {
            type: Object,
            default: () => {},
        },
        limitEntry: {
            type: Number,
            default: -1,
        },
        isHiddenButtonBack: {
            type: Boolean,
            default: false,
        },
        gameSlugActive: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dataSource: [],
            dataSourceFilter: [],
            dataSourceGames: null,
            eventSelect: [],
            eventInfo: [],
            loadingPage: true,
            isLoadingButton: false,
            numberQp: 0,
            gameNumber: 0,
        }
    },
    watch: {
        propsDataGames() {
            this.fetchdata()
            this.eventSelect = []
        },
    },
    created() {
        this.fetchdata()
        EventBus.$on('on-filter-events', (param) => this.onFilterEvents(param))
        EventBus.$on('on-events-continue', () => this.onEventContinue())
        EventBus.$on('on-change-nav-games-2', (param) => {
            this.numberQp = param.numberQp
            this.gameNumber = param.gameNumber
            // Update allowed_picks when game changes (e.g., Chance2 -> Chance3)
            if (param.allowed_picks) {
                this.dataSourceGames.allowed_picks = param.allowed_picks
            } else {
                // If no allowed_picks in param, remove it (for games without permutation)
                delete this.dataSourceGames.allowed_picks
            }
            // Update bankers when game changes
            if (param.bankers && Array.isArray(param.bankers) && param.bankers.length > 0) {
                this.dataSourceGames.bankers = param.bankers
            } else {
                delete this.dataSourceGames.bankers
            }
            // Update price if provided
            if (param.price !== undefined) {
                this.dataSourceGames.price = param.price
            }
        })
    },
    destroyed() {
        EventBus.$off('on-filter-events')
        EventBus.$off('on-events-continue')
        EventBus.$off('on-change-nav-games')
    },
    methods: {
        async fetchdata() {
            this.loadingPage = true
            try {
                let typeGame = this.propsDataGames.isPariMutuelLotto ? 'pari-mutuel-lotto' : 'multi-lotto'

                const resp = await GamesService.getListEvents(typeGame)
                if (resp.code === 200) {
                    let dataSource = resp.data

                    if(this.propsDataGames.isPariMutuelLotto) {
                        dataSource = dataSource.filter(x => x.game?.toLowerCase() === this.propsDataGames.title?.toLowerCase())
                    }

                    this.dataSource = dataSource
                    this.dataSourceFilter = dataSource
                    this.$store.dataListEvents = dataSource

                    this.dataSourceGames = this.propsDataGames
                    this.numberQp = this.propsDataGames.numberQp
                    this.gameNumber = this.propsDataGames.gameNumber

                    this.loadingPage = false
                }
            } catch (error) {
                this.loadingPage = false
                console.log(error)
            }
        },
        onSelectEvent(eventId, item) {
            const isOverLimit =
                this.limitEntry > 0 &&
                this.eventSelect.length >= this.limitEntry &&
                !this.eventSelect.includes(eventId)

            if (isOverLimit) {
                EventBus.$emit('show-notications', {
                    text: this.getTranslatedText(`You can select only [entry] event`, {
                    entry: this.limitEntry,
                    }),
                    type: 'warning',
                })
                return false
            }

            const index = this.eventSelect.findIndex((x) => x === eventId)

            if (index !== -1) {
                this.eventSelect.splice(index, 1)
                this.eventInfo.splice(index, 1)
            } else {
                this.eventSelect.push(eventId)
                this.eventInfo.push({
                    name: item.event_name,
                    date: item.draw_date,
                })
            }
        },
        renderDate(date) {
            const dateFormat = formatDate(convertDate(date))

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${this.$store.state.isScreenMobile ? `${dateFormat.hours}:${dateFormat.minutes} ${dateFormat.convertHours}` : `${dateFormat.hour24h}H${dateFormat.minutes}`} `

            return valueDate
        },
        onFilterEvents(value) {
            let dataSourceFilter = [...this.dataSource]
            if (value !== 'all') {
                dataSourceFilter = this.dataSource.filter((x) => x.event_id === value)
            }
            this.dataSourceFilter = dataSourceFilter
        },
        onEventContinue() {
            if (isArrayEmpty(this.eventSelect)) {
                const param = {
                    text: this.getTranslatedText('please choose the game'),
                    type: 'warning',
                }
                EventBus.$emit('show-notications', param)

                return false
            } else {
                let param = {
                    step: 3,
                    number: {
                        game: this.dataSourceGames.name,
                        title: this.dataSourceGames.title,
                        gameNumber: this.gameNumber,
                        numberQp: this.numberQp,
                        event_id: this.eventSelect,
                        eventInfo: this.eventInfo,
                        selection: [],
                        draws: 1,
                        wager: this.dataSourceGames.price,
                        bet_options: this.dataSourceGames.bet_options,
                        isPariMutuelLotto: this.dataSourceGames.isPariMutuelLotto,
                    },
                }

                if(!isObjEmpty(this.dataSourceGames.allowed_picks)) {
                    param.number['allowed_picks'] = this.dataSourceGames.allowed_picks
                    param.number['numberQp'] = this.dataSourceGames.allowed_picks?.max || param.number['numberQp']
                }
                
                // Add bankers if available
                if(this.dataSourceGames.bankers && Array.isArray(this.dataSourceGames.bankers) && this.dataSourceGames.bankers.length > 0) {
                    param.number['bankers'] = this.dataSourceGames.bankers
                }

                if (this.dataSourceGames.isPariMutuelLotto) param.number['maxPicks'] = this.dataSourceGames.maxPicks

                EventBus.$emit('screen-game-on-handle-steps', param)
            }
        },

    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/games/_event.scss';
</style>
